import clsx from 'clsx';

import { SVGAPR } from './SVGAPR';
import { SVGPWR } from './SVGPWR';
import { RankingBadgeProps } from './types';

export const RankingBadge = ({
	statusText,
	showBadge,
	isProPlayer,
	badgeCenterClass,
	bgColorClass,
	borderColorClass,
	textColorClass,
	size,
	year
}: RankingBadgeProps) => {
	if (!showBadge) return null;

	const textSizeClasses = {
		base: clsx('text-base leading-6', isProPlayer ? 'tracking-[-1.92px]' : 'tracking-[-1.28px]'),
		sm: clsx('text-sm leading-[18px]', isProPlayer ? 'tracking-[-1.68px]' : 'tracking-[-1.12px]')
	};

	return (
		<div className="flex flex-col pl-2 gap-[1px]">
			{year ? <span className="pl-2.5 text-gray-700 text-xs tracking-[-0.96px] leading-none italic">{year}</span> : null}
			<div className={clsx('flex w-full', badgeCenterClass)}>
				<div
					className={clsx('flex max-w-min border-2 -skew-x-[24deg] overflow-hidden rounded-tl rounded-br', borderColorClass, bgColorClass)}
				>
					<div className={clsx('bg-white py-1', { 'px-2': !isProPlayer, 'px-1': isProPlayer })}>
						<div className="skew-x-[24deg] w-full h-full flex items-center justify-center">
							{isProPlayer ? <SVGPWR size={size} /> : <SVGAPR size={size} />}
						</div>
					</div>
					<div className="skew-x-[24deg] flex items-center justify-center pl-0.5 pr-1.5">
						<h2 className={clsx('font-normal italic whitespace-nowrap', textColorClass, textSizeClasses[size])}>{statusText}</h2>
					</div>
				</div>
			</div>
		</div>
	);
};
